(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/focus-trap/assets/javascripts/use-focus-trap.js') >= 0) return;  svs.modules.push('/components/lb-utils/focus-trap/assets/javascripts/use-focus-trap.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useRef = _React.useRef;
const constants = svs.components.lbUtils.focusTrap.constants;
const logger = svs.core.log.getLogger('components:lb-utils:focus-trap:use-focus-trap');

const useFocusTrap = _ref => {
  let _ref$selectors = _ref.selectors,
    selectors = _ref$selectors === void 0 ? constants.defaultSelectors : _ref$selectors,
    _ref$refocus = _ref.refocus,
    refocus = _ref$refocus === void 0 ? true : _ref$refocus,
    _ref$onEscape = _ref.onEscape,
    onEscape = _ref$onEscape === void 0 ? null : _ref$onEscape,
    _ref$ariaHiddenElemen = _ref.ariaHiddenElements,
    ariaHiddenElements = _ref$ariaHiddenElemen === void 0 ? [] : _ref$ariaHiddenElemen;
  const trapRef = useRef(constants.state);

  const trapFocus = useCallback(function (target, cb) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!target) {
      throw new Error('No target element provided');
    }
    const queryString = selectors.join(',');
    let elements = [...target.querySelectorAll(queryString)].filter(el => el.hasAttribute('tabindex') ? el.tabIndex > -1 : true);
    if (options.addTabBefore) {
      elements = options.addTabBefore.concat(elements);
    }
    if (options.addTabAfter) {
      elements = elements.concat(options.addTabAfter);
    }
    if (elements.length === 0) {
      logger.warn('No focusable elements found inside the target');
      return;
    }
    trapRef.current.target = target;
    trapRef.current.focusableElements = elements;
    trapRef.current.first = elements[0];
    trapRef.current.last = elements[elements.length - 1];
    trapRef.current.initiator = document.activeElement;
    requestAnimationFrame(() => {
      if (ariaHiddenElements !== null && ariaHiddenElements !== void 0 && ariaHiddenElements.length) {
        document.querySelectorAll(ariaHiddenElements).forEach(element => {
          if (element) {
            element.setAttribute('aria-hidden', true);
          }
        });
      }
      if (trapRef.current.first) {
        trapRef.current.first.focus();
      }
      cb === null || cb === void 0 || cb({
        el: target,
        focusableElements: elements
      });
    });
  }, [selectors, ariaHiddenElements]);

  const releaseFocus = useCallback((newFocusEl, cb) => {
    const _trapRef$current = trapRef.current,
      target = _trapRef$current.target,
      initiator = _trapRef$current.initiator;
    const elementToFocus = newFocusEl || (refocus ? initiator : null);

    trapRef.current.target = null;
    trapRef.current.focusableElements = [];
    trapRef.current.first = null;
    trapRef.current.last = null;
    if (ariaHiddenElements !== null && ariaHiddenElements !== void 0 && ariaHiddenElements.length) {
      document.querySelectorAll(ariaHiddenElements).forEach(element => {
        if (element) {
          element.setAttribute('aria-hidden', false);
        }
      });
    }
    if (elementToFocus) {
      requestAnimationFrame(() => {
        elementToFocus.focus();
      });
    }
    cb === null || cb === void 0 || cb({
      el: target,
      newFocus: elementToFocus
    });
  }, [refocus, ariaHiddenElements]);
  useEffect(() => {
    const handleKeyDown = e => {
      const _trapRef$current2 = trapRef.current,
        first = _trapRef$current2.first,
        last = _trapRef$current2.last,
        target = _trapRef$current2.target,
        initiator = _trapRef$current2.initiator;
      if (!target) {
        return;
      }
      if (e.key === 'Tab') {
        if (document.activeElement === first && e.shiftKey) {
          e.preventDefault();
          last.focus();
        }
        if (document.activeElement === last && !e.shiftKey) {
          e.preventDefault();
          first.focus();
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        if (onEscape) {
          onEscape();
        } else {
          releaseFocus(initiator);
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscape, releaseFocus]);
  return {
    trapFocus,
    releaseFocus
  };
};
setGlobal('svs.components.lbUtils.useFocusTrap', useFocusTrap);

 })(window);